import React from "react";
import '../styles/components.css';

import { CustomTypoH4 } from "../helper/headings";

const TravelSectionItem = ({ image, heading, content }) => {
    return (
        <div className='travel-section-item' style={{ padding: "0%" }}>
            <img src={image} alt="icon" />
            <div style={{ paddingLeft: "7px", marginBottom: "10%" }}>
                <CustomTypoH4
                    typo={heading}
                />
                <p>
                    {content}
                </p>
            </div>
        </div>
    )
}
export default TravelSectionItem;